import React from 'react';
import Joyride from 'react-joyride';

const ResultsPageTour = ({ run, onFinish, dontShowAgain, setDontShowAgain }) => {
  const steps = [
    {
      target: '#column-filter-dropdown',
      content: 'Use this dropdown to filter results by specific columns.',
      disableBeacon: true,
      placement: 'bottom'
    },
    {
      target: '#results-search-bar',
      content: 'Or quickly search for keywords to verify specific results.',
      placement: 'bottom',
      spotlightClicks: true
    },
    {
      target: '[data-decision-chip="true"]',
      content: 'See the AI\'s choices and the reasons behind them. If you don\'t agree, just click the <strong>Qualified</strong>/<strong>Disqualified</strong> button to instantly change the decision.',
      placement: 'top',
      spotlightClicks: true
    },
    {
      target: '#frequency-column-header',
      content: 'Results are sorted by the number of times each value appears on your list, so you can quickly review the decisions that have the largest impact on your results.',
      placement: 'bottom',
      spotlightClicks: true
    },
    {
      target: '#save-template-button',
      content: 'Happy with these results? Save this criteria as a template to reuse on future data.',
      placement: 'top',
      spotlightClicks: true
    },
    {
      target: '#export-results-button',
      content: "Once you've reviewed your results, download your decisions along with the original file here.",
      placement: 'bottom',
      spotlightClicks: true
    }
  ];
  
  const handleCallback = (data) => {
    const { status } = data;
    if (status === 'finished' || status === 'skipped') {
      onFinish();
    }
  };
  
  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showSkipButton={false}
      disableOverlayClose={true}
      disableCloseOnEsc={true}
      callback={handleCallback}
      tooltipComponent={({ continuous, index, step, backProps, closeProps, primaryProps, skipProps, tooltipProps }) => (
        <div {...tooltipProps} style={{ ...tooltipProps.style, maxWidth: 400 }}>
          <div style={{ padding: '20px', backgroundColor: '#1e2439', borderRadius: '8px' }}>
            {step.title && <h4 style={{ color: '#ffffff', marginBottom: '10px' }}>{step.title}</h4>}
            <div 
              style={{ color: '#ffffff', marginBottom: '20px' }}
              dangerouslySetInnerHTML={{ __html: step.content }}
            />
            
            {/* Add checkbox for don't show again on the last step */}
            {index === steps.length - 1 && (
              <div style={{ 
                marginBottom: '15px', 
                padding: '10px', 
                backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <input
                  type="checkbox"
                  id="dontShowAgain"
                  checked={dontShowAgain}
                  onChange={(e) => setDontShowAgain(e.target.checked)}
                  style={{ marginRight: '10px', cursor: 'pointer' }}
                />
                <label 
                  htmlFor="dontShowAgain" 
                  style={{ 
                    color: '#ffffff', 
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    margin: 0
                  }}
                >
                  Don't show this tutorial again
                </label>
              </div>
            )}
            
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {index > 0 && (
                <button {...backProps} style={{ 
                  backgroundColor: 'transparent', 
                  color: '#0095FF', 
                  border: '1px solid #0095FF',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>
                  Back
                </button>
              )}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                {continuous && primaryProps && (
                  <button {...primaryProps} style={{ 
                    backgroundColor: '#0095FF', 
                    color: '#ffffff', 
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}>
                    {index === steps.length - 1 ? 'Finish' : 'Next'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      styles={{
        options: {
          primaryColor: '#0095FF',
          backgroundColor: '#1e2439',
          textColor: '#ffffff',
          overlayColor: 'rgba(0, 0, 0, 0.7)'
        },
        overlay: {
          cursor: 'default'
        }
      }}
    />
  );
};

export default ResultsPageTour;